import React from 'react';
import "../css/aboutus.css";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const Aboutus = ({ data }) => {
  if (!data) return <p>Loading...</p>;

  return (
    <>
      <div className='about-container'>
        <div className='about-left'>
          <div className='breadcrum'>
            <div className='heading-wrapper'>
              <h1 className='about-heading'>
                <strong>{data.about_heading}</strong> <span>{data.about_subheading}</span>
                <span className='about-heading-bg'>{data.about_heading} {data.about_subheading}</span> 
              </h1>
            </div>
            <Link className='home-link' to="/">{data.home_link_text}</Link>
            <span className='seperator'>|</span>
            <span className='aboutus-link'>{data.about_heading} {data.about_subheading}</span>
          </div>
        </div>
        <div className='about-right'>
          <img src={data.about_image} alt="team working" className='about-image' width="300px" height="300px" opacity="0.1" />
        </div> 
      </div>

      <div className="company-info-section">
        <div className="info-left">
          <h2>{data.company_heading}</h2>
          <p>{data.company_paragraph}</p>
        </div>
        <div className="info-right">
          <div className="stats-box box-bottom-right" style={{backgroundImage:`url(${data.box_bottom_right_img})`}}>
            <div className="text-overlay">
              <h3>{data.years_experience}</h3>
              <p>{data.experience_text_label}</p>
            </div>
          </div>
          <div className="image-stack" style={{backgroundImage:`url(${data.image_stack_bg})`}}>
            <div className="stats-box box-top-right" style={{backgroundImage:`url(${data.box_top_right_img})`}}>
              <div className="text-overlay">
                <h3>{data.expert_team_count}</h3>
                <p>{data.team_text_label}</p>
              </div>
            </div>
            <div className="stats-box box-middle-left" style={{backgroundImage:`url(${data.box_middle_left_img})`}}>
              <div className="text-overlay">
                <h3>{data.client_satisfaction}</h3>
                <p>{data.client_text_label}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='choosecomp'>
        <div className='choose-comp-left'>
          <div className="image-row">
            <div className="image-with-box">
              <img src={data.choose_img1} alt="Team working" className="choose-image left-image" />
              <div className="experience-box">
                <h1>{data.choose_experience_years}</h1>
                <p>{data.choose_experience_text}</p>
              </div>
            </div>
            <img src={data.choose_img2} alt="Consultation" className="choose-image right-image" />
          </div>
        </div>
        <div className='choose-comp-right'>
          <h2 className='choose-comp-right-heading'>
            <strong>{data.choose_heading}</strong>
            <span>{data.choose_subheading}</span>
          </h2>
          <p className='choose-r-para-one'>{data.choose_description}</p>
          <ul className='choose-r-para-two'>
            <li>{data.point1}</li>
            <li>{data.point2}</li>
            <li>{data.point3}</li>
            <li>{data.point4}</li>
            <li>{data.point5}</li>
          </ul>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.aboutus.data,
});

export default connect(mapStateToProps)(Aboutus);

